import React from 'react'

import { useNavigate , useLocation } from "react-router-dom";


export default function Facturacion() {



    const navigate = useNavigate();

    

    function showSome(){
        alert("show some")
    }


    function onProductos()
    {
      //clear() ; // Dejamos pendiente el cliear

      //setVisible( false)
      
        navigate( "/productos" )
    }

    function onViewXml()
    {
        navigate( "/viewxml" )
    }

  return (
    <div className='w-100'>

    <h4>Facturacion</h4>

    <div className='nav mb-5' style={{width:'100%'}}>
        <ul>
            <li><a onClick={showSome} href="#home" class="active" >Cuentas</a></li>
            <li><a onClick={onProductos} href="#Excel">Productos</a></li>
            <li><a onClick={onViewXml} href="#Xml">VerXml</a></li>
            <li><a href="#about">About</a></li>
        </ul>
    </div>
</div>
  )
}
